/**
 * @generated SignedSource<<15f9429c893697d2c7c552cb93e59d94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeliveryRow_delivery$data = {
  readonly id: string;
  readonly response: {
    readonly status: number;
  };
  readonly timestamp: number;
  readonly " $fragmentType": "DeliveryRow_delivery";
};
export type DeliveryRow_delivery$key = {
  readonly " $data"?: DeliveryRow_delivery$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeliveryRow_delivery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeliveryRow_delivery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WebHookDeliveryResponse",
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WebHookDelivery",
  "abstractKey": null
};

(node as any).hash = "19b869f969e29666283b072fbc32e9de";

export default node;
